(function ($, Cobalt, undefined) {
    Cobalt.Announcement = {
        cookieName: "Cobalt.SeenAnnouncements",
        containerName: ".link-annoucement",
        countContainerName: ".notify-count",
        initialize: function () {
            var container = $(Cobalt.Announcement.containerName);

            if (!container || container.length < 1) {
                return;
            }

            var countContainer = container.find(Cobalt.Announcement.countContainerName);

            if (!countContainer || countContainer.length < 1) {
                return;
            }

            var announcementCookie = $.cookie(Cobalt.Announcement.cookieName);
            var hash = container.attr('data-hash');

            if (hash === announcementCookie) {
                $(Cobalt.Announcement.containerName).removeClass("link-annoucement-unread").text('');
            }
            else if (announcementCookie != null && hash != null) { //if they arent the same, we split them into the individual parts, and see if there is a new one, this is to deal with removing announcements

                var oldHashParts = announcementCookie.split("-");
                var newHashParts = hash.split("-");
                var same = true;
                for (var i = 0; i < newHashParts.length; i++) {
                    if (oldHashParts.indexOf(newHashParts[i]) == -1) {
                        same = false;
                    }
                }

                // If the hashes match, remove the unread class, and update the hashes.
                if (same) {
                    $(Cobalt.Announcement.containerName).removeClass("link-annoucement-unread");
                    $.cookie(Cobalt.Announcement.cookieName, hash);
                }
                // If the hashes do not match, show the count container.
                else {
                    countContainer.show();
                }
            }

            $(Cobalt.Announcement.containerName).mouseover(function () {
                countContainer.hide();
                $.cookie(Cobalt.Announcement.cookieName, hash, { 'expires': 365 });
                $(this).removeClass("link-annoucement-unread");
            });
        }
    }
} (jQuery, Cobalt));


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Announcement.js